import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import "../../assets/css/Care-Registration.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import config from "../../config";
import { UpdateServiceAction } from "../../redux/actions/auth";

const EditService = ({ navigation, auth, services, updateService }) => {
    const { id } = useParams();

    const navigate = useNavigate();
    const [service, setService] = useState({});
    const [userService, setUserService] = useState({});
    const [loading, setLoading] = useState(true);

    const [hourAvailability, setHourAvailability] = useState([]);
    const [serviceForAge, setServiceForAge] = useState([]);
    const [cancellationPolicy, setCancellationPolicy] = useState([]);

    const [serviceType, setServiceType] = useState([]);
    const [schedule, setSchedule] = useState({
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
    });

    const getServicesMeta = async (service_id) => {
        try {
            const res = await config.getApi(
                config.services.servicesMeta(service_id)
            );
            if (res) {
                console.log(res.response.data);
                setHourAvailability(res.response.data.hours_per_day);
                setServiceForAge(res.response.data.service_for_ages);
                setCancellationPolicy(res.response.data.cancellation_policy);
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        let userServicee = auth.user.services.filter(
            (singleUserService) => singleUserService.id == id
        );
        if (userServicee.length > 0) {
            setUserService(userServicee[0]);
            setServiceType(userServicee[0].service_types || []);
            getServicesMeta(userServicee[0].service_id);
        }
        let servicee = services.filter(
            (singleService) => singleService.id == userServicee[0].service.id
        );
        if (servicee.length > 0) {
            setService(servicee[0]);
        }
        let schedulee = auth.user.schedule.filter(
            (singleSchedule) =>
                singleSchedule.service_id == userServicee[0].service.id
        );
        let newSchedule = { ...schedule };
        schedulee.map((singleSchedule) => {
            newSchedule[singleSchedule.availability] = true;
        });
        setSchedule(newSchedule);
        setLoading(false);
    }, []);

    const onServiceTypeChange = (e) => {
        if (serviceType.includes(e.target.value)) {
            let newServiceType = serviceType.filter(
                (singleServiceType) => singleServiceType != e.target.value
            );
            setServiceType(newServiceType);
        } else {
            let newServiceType = [...serviceType, e.target.value];
            setServiceType(newServiceType);
        }
    };

    const onScheduleDaysChange = (e) => {
        let newSchedule = { ...schedule };
        newSchedule[e.target.value] = !newSchedule[e.target.value];
        setSchedule(newSchedule);
    };

    const onHourAvailabilityChange = (e) => {
        let newUserService = { ...userService };
        newUserService.hour_availability_id = e.target.value;
        setUserService(newUserService);
    };

    const onServiceForAgeChange = (e) => {
        let newUserService = { ...userService };
        newUserService.service_for_age_id = e.target.value;
        setUserService(newUserService);
    };

    const onCancellationPolicyChange = (e) => {
        let newUserService = { ...userService };
        newUserService.cancellation_policy_id = e.target.value;
        setUserService(newUserService);
    };

    const submit = async () => {
        try {
            let newUserService = { ...userService };
            newUserService.service_types = serviceType;
            updateService(
                service.id,
                JSON.stringify({
                    user_service: newUserService,
                    schedule: schedule,
                })
            ).then(() => {
                Swal.fire({
                    icon: "success",
                    title: "Updated",
                    text: "Service Updated Successfully!",
                });
                navigate('/my-services');
            });
        } catch (e) {
            console.log(e);
        }
    };

    if (loading) {
        return <div />;
    }
    return (
        <>
            <Header />
            {/* <!-- Care Giver Registration Form --> */}
            <div className="care-registration">
                <div className="container">
                    <div className="top_bar">
                        <div className="heading_wrapper">
                            <h2>Edit Service</h2>
                            <p>
                                Edit all the services you are offering with a
                                few mouse clicks. Whether you want to make an
                                addition to your caregiving services or delete
                                the existing ones, it’s as easy as 1-2-3.
                            </p>
                        </div>
                        <div className="button-group">
                            <button
                                type="button"
                                onClick={submit}
                                className="btn ml-2"
                                style={{
                                    backgroundColor: "#ff5735",
                                    color: "#fff",
                                }}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                    <div id="wizard">
                        <section id="tabcontent" className="second_tab">
                            <div className="head_wrapper">
                                <h5>Services Setup</h5>
                                <p>
                                    Select Services you want to provide .You can
                                    select multiple service
                                </p>
                            </div>
                            <div className="card">
                                <div
                                    id="formonecollapse"
                                    className="collapse show"
                                    aria-labelledby="formone"
                                    data-parent="#accordion"
                                >
                                    <div className="card-body">
                                        <div className="offering_service">
                                            <label>
                                                Mark the Services which you are
                                                offering in {service.title}.{" "}
                                            </label>
                                            <div className="checkboxes">
                                                {service.service_types.map(
                                                    (singleServiceType) => (
                                                        <div
                                                            className="form-group"
                                                            key={
                                                                singleServiceType.id
                                                            }
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                className="mt-1"
                                                                id={
                                                                    singleServiceType.title
                                                                }
                                                                value={
                                                                    singleServiceType.title
                                                                }
                                                                checked={serviceType.includes(
                                                                    singleServiceType.title
                                                                )}
                                                                onChange={
                                                                    onServiceTypeChange
                                                                }
                                                            />
                                                            <label
                                                                htmlFor={
                                                                    singleServiceType.title
                                                                }
                                                            >
                                                                {
                                                                    singleServiceType.title
                                                                }
                                                            </label>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                        <div className="others">
                                            {/* <div className="form-group">
                                                <div className="input_field">
                                                    <label htmlFor="specify">
                                                        Other (please specify)
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Specify Your Service "
                                                    />
                                                </div>
                                                <div className="note">
                                                    <span>
                                                        <ruby>Note:</ruby>{" "}
                                                        please Specify if the
                                                        service you offer is not
                                                        listed above
                                                    </span>
                                                </div>
                                            </div> */}
                                            <div className="form-group pt-4">
                                                <div className="input_field">
                                                    <label htmlFor="specify">
                                                        Per hour charges clients
                                                        to pay per service:
                                                    </label>
                                                    <input
                                                        min={1}
                                                        step={0.01}
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="$"
                                                        value={
                                                            userService.per_hour
                                                        }
                                                        onChange={(e) => {
                                                            let newUserService =
                                                                {
                                                                    ...userService,
                                                                };
                                                            newUserService.per_hour =
                                                                e.target.value;
                                                            setUserService(
                                                                newUserService
                                                            );
                                                        }}
                                                    />
                                                </div>
                                                <div className="note">
                                                    <span>
                                                        <ruby>Note:</ruby> What
                                                        you’ll earn per service:
                                                        $
                                                        {parseFloat(
                                                            userService.per_hour *
                                                                0.9
                                                        ).toFixed(2)}{" "}
                                                        | 10% processing fee
                                                        will be charge
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="week_days">
                                            <p>
                                                What days of the week will you
                                                typically be available?
                                            </p>
                                            <ul className="days">
                                                <li>
                                                    <div className="form-group">
                                                        <label htmlFor="mon">
                                                            Mon
                                                        </label>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            id="mon"
                                                            value={"monday"}
                                                            onChange={
                                                                onScheduleDaysChange
                                                            }
                                                            checked={
                                                                schedule[
                                                                    "monday"
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="form-group">
                                                        <label htmlFor="tue">
                                                            Tue
                                                        </label>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            id="tue"
                                                            value={"tuesday"}
                                                            onChange={
                                                                onScheduleDaysChange
                                                            }
                                                            checked={
                                                                schedule[
                                                                    "tuesday"
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="form-group">
                                                        <label htmlFor="wed">
                                                            Wed
                                                        </label>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            id="wed"
                                                            value={"wednesday"}
                                                            onChange={
                                                                onScheduleDaysChange
                                                            }
                                                            checked={
                                                                schedule[
                                                                    "wednesday"
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="form-group">
                                                        <label htmlFor="thur">
                                                            Thurs
                                                        </label>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            id="thur"
                                                            value={"thursday"}
                                                            onChange={
                                                                onScheduleDaysChange
                                                            }
                                                            checked={
                                                                schedule[
                                                                    "thursday"
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="form-group">
                                                        <label htmlFor="fri">
                                                            Fri
                                                        </label>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            id="fri"
                                                            value={"friday"}
                                                            onChange={
                                                                onScheduleDaysChange
                                                            }
                                                            checked={
                                                                schedule[
                                                                    "friday"
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="form-group">
                                                        <label htmlFor="sat">
                                                            Sat
                                                        </label>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            id="sat"
                                                            value={"saturday"}
                                                            onChange={
                                                                onScheduleDaysChange
                                                            }
                                                            checked={
                                                                schedule[
                                                                    "saturday"
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="form-group">
                                                        <label htmlFor="sun">
                                                            Sun
                                                        </label>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            id="sun"
                                                            value={"sunday"}
                                                            onChange={
                                                                onScheduleDaysChange
                                                            }
                                                            checked={
                                                                schedule[
                                                                    "sunday"
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="hoursDv combined_radios">
                                            <p>
                                                How many hours per day you are
                                                available on average
                                            </p>
                                            <ul className="hours_radios combined_list row">
                                                {hourAvailability.map(
                                                    (
                                                        singleHourAvailability
                                                    ) => (
                                                        <li
                                                            className="col-md-3"
                                                            key={`hour_availability_${singleHourAvailability.id}`}
                                                        >
                                                            <label className="hours_container combined_container">
                                                                {singleHourAvailability.min_hours +
                                                                    " - " +
                                                                    singleHourAvailability.max_hours +
                                                                    " Hours / Day"}
                                                                <input
                                                                    type="radio"
                                                                    checked={
                                                                        userService.hour_availability_id ==
                                                                        singleHourAvailability.id
                                                                    }
                                                                    name="hours_radio"
                                                                    value={
                                                                        singleHourAvailability.id
                                                                    }
                                                                    onChange={
                                                                        onHourAvailabilityChange
                                                                    }
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                        <div className="ageDv combined_radios">
                                            <p>Select your Age Range</p>
                                            <ul className="age_radios combined_list row">
                                                {serviceForAge.map(
                                                    (singleServiceForAge) => (
                                                        <li
                                                            className="col-md-3"
                                                            key={`service_for_age_${singleServiceForAge.id}`}
                                                        >
                                                            <label className="age_container combined_container">
                                                                {config.monthsYearsFormatter(
                                                                    singleServiceForAge.min_age
                                                                ) +
                                                                    " - " +
                                                                    config.monthsYearsFormatter(
                                                                        singleServiceForAge.max_age
                                                                    )}
                                                                <input
                                                                    type="radio"
                                                                    checked={
                                                                        userService.service_for_age_id ==
                                                                        singleServiceForAge.id
                                                                    }
                                                                    name="age_radio"
                                                                    value={
                                                                        singleServiceForAge.id
                                                                    }
                                                                    onChange={
                                                                        onServiceForAgeChange
                                                                    }
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                        <div className="childcare combined_radios p-0" style={{visibility:'hidden'}}>
                                            {/*<p>*/}
                                            {/*    What is the Cancellation Policy*/}
                                            {/*</p>*/}
                                            <ul className="childcare combined_list row">
                                                {cancellationPolicy.map(
                                                    (singleCancelPolicy) => (
                                                        <li
                                                            className="col-md-3"
                                                            key={`cancel_policy_${singleCancelPolicy.id}`}
                                                        >
                                                            <label className="childcare combined_container">
                                                                {(singleCancelPolicy.days ==
                                                                0
                                                                    ? "Same"
                                                                    : singleCancelPolicy.days) +
                                                                    " Day(s)"}
                                                                <input
                                                                    type="radio"
                                                                    checked={
                                                                        userService.cancellation_policy_id ==
                                                                        singleCancelPolicy.id
                                                                    }
                                                                    name="child_radio"
                                                                    value={
                                                                        singleCancelPolicy.id
                                                                    }
                                                                    onChange={
                                                                        onCancellationPolicyChange
                                                                    }
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <a href="#" style={{color:'#000'}}>Terms of Service</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Care Giver Registration Form --> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    services: state.services,
});

const mapDispatchToProps = (dispatch) => ({
    updateService: (service_id, payload) =>
        dispatch(UpdateServiceAction(service_id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditService);
